import addYears from 'date-fns/addYears';
import lastDayOfYear from 'date-fns/lastDayOfYear';
import setMonth from 'date-fns/setMonth';
import { getLastMonday } from './getLastMonday';

export function getMaxDate(date, options = { month: null, years: null }) {
  const DEFAULT_MAX_MONTH = 11;
  const DEFAULT_MAX_YEARS = 0;
  const maxMonth = options?.month ?? DEFAULT_MAX_MONTH;
  const maxYears = options?.years ?? DEFAULT_MAX_YEARS;
  const maxDate = lastDayOfYear(addYears(setMonth(date, maxMonth), maxYears));

  return getLastMonday(maxDate);
}
